
import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'welcome',
        component: () => import('@/views/welcome'),
        meta: { title: '欢迎', }// 需要登录
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/register'),
        meta: { title: '注册'}
    },
    {
        path: '/booking',
        name: 'booking',
        component: () => import('@/views/booking'),
        meta: { title: '预约'}
    },    {
        path: '/bookingHistory',
        name: 'bookingHistory',
        component: () => import('@/views/booking/bookingHistory.vue'),
        meta: { title: '预约历史'}
    },
    {
        path: '/user',
        name: 'user',
        component: () => import('@/views/user'),
        meta: { title: '个人中心'}
    },
    {
        path: '/history',
        name: 'history',
        component: () => import('@/views/history'),
        meta: { title: '历史订单'}
    },    {
        path: '/balance',
        name: 'balance',
        component: () => import('@/views/balance'),
        meta: { title: '余额'}
    },

    {
        path: '/oauth2',
        name: 'oauth2',
        component: () => import('@/views/oauth2'),
        meta: { title: '授权'}
    },

]

const router = new VueRouter({
    mode: 'hash', // 公众号必须使用hash模式
    base: process.env.BASE_URL,
    routes
})
// 路由守卫
router.beforeEach((to, from, next) => {
    // 设置页面标题
    if (to.meta.title) {
        document.title = to.meta.title
    }

    // 检查是否需要登录
    // if (to.meta.requireAuth) {
    //     const token = localStorage.getItem('teaToken')
    //     if (!token) {
    //         next({
    //             path: '/login',
    //             query: { redirect: to.fullPath }
    //         })
    //         return
    //     }
    // }

    next()
})
export default router
